import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=094e7bf6"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('094e7bf6')) {
      api.createRecord('094e7bf6', component.options)
    } else {
      api.reload('094e7bf6', component.options)
    }
    module.hot.accept("./buttons.vue?vue&type=template&id=094e7bf6", function () {
      api.rerender('094e7bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/buttons.vue"
export default component.exports